/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Payment status.
 */
export enum PaymentStatus {
    PENDING = 'pending',
    STARTED = 'started',
    CLEARED = 'cleared',
}
